/** @module colors/reports

Color palette for use within report charts. These are intended to define
developer friend names, and groupings for use within charts.
*/

import {colors} from './colors';

const purple = '#7373c7';
const blue = '#61b2de';
const orange = '#ff7833';
const navy = '#3d405c';
const yellow04 = '#fcd469';
const teal = '#62d4ca';

// 15% opacity variants for funnel report distribution bars
const greenDk15 = '#2e994226';
const yellow0415 = '#fcd46926';
const reportRed15 = '#ff596b26';
const reportBlue15 = '#61b2de26';
const blueDk15 = '#337da826';
const teal15 = '#62d4ca26';

export const NONE = '#d4d1cf';
export const OTHER = '#e3e0e0';
export const BASE_BAR_COLOR = navy;
export const WON_GREEN = colors.reportGreen;
export const LOST_RED = colors.reportRed;
export const OPEN_BLUE = colors.reportBlue;

// The order of colors is dependent on the number of segments with colors being
// inserted at different points to maximize contrast.
export const SegmentColors = [
    [purple],
    [purple, blue],
    [navy, purple, blue],
    [navy, purple, yellow04, blue],
    [navy, blue, purple, yellow04, orange],
    [navy, blue, purple, teal, yellow04, orange],
] as const;

export const StatusColors = {
    Won: WON_GREEN,
    Lost: LOST_RED,
    Cancelled: colors.grey,
    Open: OPEN_BLUE,
    Pending: colors.offWhiteDk,
} as const;

export const OutcomeColors = {
    Won: WON_GREEN,
    'Lost/Cancelled': LOST_RED,
    Unknown: colors.offWhiteDk,
} as const;

export const SubscriptionStatusColors = {
    'Existing members': BASE_BAR_COLOR,
    'New members': WON_GREEN,
    Unsubscribes: LOST_RED,
    'Opt-outs': orange,
    'Unsubscribed and opted-out': colors.tagPurpleDk,
} as const;

export const TaskColors = {
    'Completed on time': colors.greenDk,
    'Completed late': colors.yellow,
    Skipped: colors.rcfxSidebarActive,
    'Not completed': colors.rose,
} as const;

export const QuoteStatusColors = {
    Sent: colors.navy,
    Accepted: colors.greenDk,
} as const;

export const InvoiceStatusColors = {
    Sent: colors.navy,
    Paid: colors.greenDk,
} as const;

export const CompletedActionsColors = {
    Bookings: colors.greenDk,
    Calls: yellow04,
    Texts: LOST_RED,
    Quotes: OPEN_BLUE,
    Chats: colors.blueDk,
    Emails: teal,
} as const;

// Same colors as CompletedActionsColors but with 15% opacity for funnel report distribution bars
export const CompletedActionsColorsFunnel = {
    Bookings: greenDk15,
    Calls: yellow0415,
    Texts: reportRed15,
    Quotes: reportBlue15,
    Chats: blueDk15,
    Emails: teal15,
} as const;
